module.exports = __webpack_public_path__ + "static/TNM079___Modeling_And_Animation__Lab_2-44698628053e167c9efa6203f2f33238.pdf";